import { defineModule } from "@motolynk/app-core";

import en from "./i18n/en.json";

export const logisticsModule = defineModule({
  name: "logistics",
  label: "Logistics",
  requires: ["core", "geo", "accounts", "configuration", "audit", "medialib"],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "settings/shipping",
        permission: "logistics.view_shippingrate",
        page: () => import("./admin/ShippingPage"),
      },
      {
        path: "settings/couriers",
        permission: "logistics.view_courier",
        page: () => import("./admin/CouriersPage"),
      },
    ],
    nav: [
      {
        id: "shipping",
        group: "settings",
        label: "logistics:shipping.nav",
        icon: "truck",
        to: "/settings/shipping",
        permission: "logistics.view_shippingrate",
        order: 5,
      },
      {
        id: "couriers",
        group: "settings",
        label: "logistics:couriers.nav",
        icon: "package",
        to: "/settings/couriers",
        permission: "logistics.view_courier",
        order: 6,
      },
    ],
  },
});
